export enum RecentChangeMetric {
  CRE = 'cre_1y',
  CQS = 'cqs',
}

export interface RecentChangeListItemDto {
  cs_companyid: string;
  display_name: string;
  cre_1y?: number;
  cre_previous?: number;
  cqs?: number;
  cqs_previous?: number;
  calc_date?: string;
}

export type RecentChangeListDto = RecentChangeListItemDto[];
